import { inject, Injectable } from '@angular/core';
import { JepBasemap } from '@jeppesen-foreflight/jmkw-types';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter, shareReplay } from 'rxjs/operators';
import { BasemapRegistryService } from './basemap-registry.service';
import { AvailableBasemaps, BasemapKey } from './basemap.config';

@Injectable({ providedIn: 'root' })
export class BasemapManagerService {
  private readonly _registry = inject(BasemapRegistryService);
  private readonly _basemapChangeSubject =
    new BehaviorSubject<JepBasemap | null>(null);

  public readonly basemapChange$: Observable<JepBasemap> =
    this._basemapChangeSubject.pipe(
      filter((basemap): basemap is JepBasemap => basemap !== null),
      distinctUntilChanged()
    );

  public readonly currentBasemap$: Observable<JepBasemap> =
    this.basemapChange$.pipe(shareReplay(1));
  public readonly basemaps$ = this._registry.basemaps$;

  public get availableBasemaps(): AvailableBasemaps {
    return this._registry.getBasemaps();
  }

  public get currentBasemap(): JepBasemap | null {
    return this._basemapChangeSubject.value;
  }

  public getBasemapById(id?: BasemapKey | null | undefined): JepBasemap | undefined {
    return id ? this._registry.getBasemaps()[id] : undefined;
  }

  public setBasemapById(id?: BasemapKey | null | undefined): void {
    const basemap = this.getBasemapById(id);
    if (basemap) {
      this._basemapChangeSubject.next(basemap);
    }
  }

  public registerBasemap(basemap: JepBasemap): void {
    this._registry.registerBasemap(basemap);
  }
}
